import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  margin: 0;
  /* max-width: 1200px; */
  box-sizing: border-box;
  padding: 0;
`;

export const LogoImage = styled.img`
  width: 10%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const FooterWrapper = styled.div`
  margin-top: auto;
`;
